import { ParentTypes as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ObjectToolbarConfig } from 'src/blocks/object-toolbar';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import { useObjectToolbarFormStore } from 'src/blocks/object-toolbar/useObjectToolbarFormStore';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common']);
  const title = t('third_party.create_title');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('dynamic_forms');
  const formConfig = useObjectToolbarFormStore((s) => s.formConfigState);
  const toolbarConfig: ObjectToolbarConfig = useMemo(
    () => ({
      header: { title },
      actions: {
        overflow: formConfig
          ? [
              {
                id: 'edit',
                label: t('edit'),
                actions: [
                  {
                    id: 'edit-form',
                    label: t('edit_form'),
                    iconName: 'file-06' as const,
                    onClick: formConfig.openConfigure,
                  },
                ],
              },
            ]
          : [],
      },
    }),
    [title, t, formConfig]
  );
  const tabs = useTabs({
    parentType: Parent_Type_Enum.ThirdParty,
    parent: null,
    hrefRoot: `third-party/add`,
    disabled: true,
  });

  return (
    <PageLayout
      title={title}
      // Sole "Configure form" route.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={toolbarConfig} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.ThirdParty}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
